<template>
  <v-app :style="'background-color:' + _backgroudcolor">
    <v-content>
      <v-layout mt-2 row wrap align-center justify-center>
        <v-flex sm4 md7 lg7 pl-5>
          <v-card class="mx-auto elevation-0" outlined color="transparent">
            <v-card-title>
              <v-avatar :color="_pageDetailcolor">
                <v-icon dark>mdi-text-box-plus</v-icon>
              </v-avatar>
              <h4
                class="ml-2"
                :style="'font-size: 18px; color:' + _pageDetailcolor"
              >
                {{ $t("portaltoolbar.bill.setting_number") }}
              </h4>
            </v-card-title>
          </v-card>
        </v-flex>
        <v-flex sm8 md5 lg5 text-right pr-10>
          <DialogTestSystem></DialogTestSystem>
        </v-flex>
      </v-layout>

      <!--<v-container grid-list-lg fluid mt-n4>-->
      <v-layout row wrap justify-center>
        <v-flex lg12 md12 sm12 xs12 pb-2 pt-4 pr-8 pl-8>
          <v-card flat class="elevation-0">
            <div class="container mt-n4 pr-2 pl-2">
              <v-card outlined class="ma-4" style="border-radius: 10px">
                <v-card-title class="pa-3" style="background-color: #fafafa">
                  <b> {{ $t("running_number.title_config") }}</b>
                </v-card-title>
                <v-divider />
                <v-card-text>
                  <v-layout row wrap justify-center class="pt-5">
                    <v-flex lg4 md4 sm4>
                      <div class="d-flex">
                        <span class="ml-5"
                          ><b>{{
                            $t("running_number.condition.reset_doc_number")
                          }}</b>
                          <div style="width: 200px">
                            <v-select
                              v-model="dateFilterType"
                              :items="$t('running_number.options')"
                              item-text="text"
                              item-value="value"
                              outlined
                              dense
                              color="primary"
                              attach
                              return-object
                              class="float-right mt-2"
                              :menu-props="{ top: false, offsetY: true }"
                            />
                          </div>
                        </span>
                      </div>
                    </v-flex>
                    <v-flex lg5 md5 sm5 class="text-left">
                      <span class="mx-10"
                        ><b>{{
                          $t("running_number.condition.reset_doc_type")
                        }}</b>
                        <div class="d-flex mx-10">
                          <v-checkbox
                            v-model="check_sourcesystem"
                            hide-details
                            :label="
                              $t('running_number.condition.source_system')
                            "
                            color="blue"
                          />
                          <v-checkbox
                            v-model="check_branch"
                            hide-details
                            :label="$t('running_number.condition.branch')"
                            color="blue"
                            class="mx-10"
                          />
                        </div>
                      </span>
                    </v-flex>
                    <v-flex lg3 md3 sm3>
                      <center>
                        <v-btn
                          class="white--text mr-4 mt-7"
                          color="success"
                          :disabled="
                            !check_sourcesystem &&
                            !check_branch &&
                            dateFilterType === undefined
                          "
                          @click="fn_confirmChoice()"
                        >
                          <v-icon class="mr-1"> mdi-content-save </v-icon>
                          <span style="font-size: 13px"
                            ><b>{{
                              $t("running_number.condition.save")
                            }}</b></span
                          >
                        </v-btn>
                      </center>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </div>
          </v-card>
          <br />
          <v-card flat class="elevation-0">
            <v-card-text>
              <v-form>
                <v-layout row wrap justify-left align-center pb-1 pa-2>
                  <v-flex lg5 md5 sm5 xs6 :mt-n4="$vuetify.breakpoint.mdAndUp">
                    <b class="text-left"
                      >{{ $t("running_number.detail.doc_found") }}
                      <v-chip outlined color="blue" class="ml-2">
                        {{ totalItem || 0 }}
                      </v-chip>
                    </b>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex lg5 md5 sm5 xs6>
                    <div class="d-flex">
                      <!--<div style="width: 100%">
                          <v-select
                            v-model="web_service"
                            :items="itemsSystem"
                            item-text="text"
                            item-value="value"
                            dense
                            outlined
                            :label="$t('running_number.condition.system')"
                            class="mr-3"
                            disabled
                            :menu-props="{ button: true, offsetY: true }"
                            @input="fn_loadData()"
                          />
                        </div>-->
                      <div style="width: 100%">
                        <!-- ช่องค้นหาคีย์ที่ต้องการ -->
                        <v-text-field
                          v-model="search"
                          outlined
                          clearable
                          :label="$t('running_number.condition.search')"
                          type="text"
                          dense
                          class="mr-3"
                          :color="_pageDetailcolor"
                        />
                      </div>
                      <v-btn
                        class="white--text float-right"
                        color="primary"
                        :loading="loading"
                        style="width: 160px"
                        @click="fn_createForm()"
                      >
                        <v-icon class="mr-1"> mdi-plus </v-icon>
                        <span style="font-size: 13px"
                          ><b>{{
                            $t("running_number.btn_create_form")
                          }}</b></span
                        >
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
                <!--OLD-->
                <!--<v-layout row wrap justify-left align-center class="mt-2">
                    <v-flex lg3 xs3 class="text-right">
                      <v-text-field
                        append-icon="mdi-magnify"
                        v-model="search"
                        outlined
                        clearable
                        :label="$t('running_number.condition.title')"
                        type="text"
                        dense
                        :color="_pageDetailcolor"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex lg8 xs8 class="text-right pb-10">
                      <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            :color="_pageDetailcolor"
                            dark
                            v-bind="attrs"
                            v-on="on"
                            @click="fn_createForm()"
                          >
                            <v-icon class="mr-2">mdi-plus</v-icon
                            >{{ $t("running_number.btn_create_form") }}
                          </v-btn>
                        </template>
                      </v-menu>
                    </v-flex>
                  </v-layout>-->
              </v-form>
            </v-card-text>
            <!-- -------------------- ส่วนของ table --------------------- -->
            <v-card-text>
              <div class="table-stlye th-stlye th-first th-last mt-n6">
                <v-data-table
                  class="rounded-lg"
                  flat
                  :headers="headers"
                  :items="itemFilter"
                  hide-default-footer
                  @page-count="pageCount = $event"
                  :page.sync="page"
                  :items-per-page="itemsPerPage"
                  :search="search"
                >
                  <template v-slot:header.doc_type_code="{ header }">
                    {{ header.text }}
                    <v-tooltip right>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          @click="fn_descriptionDocType"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          >mdi-information</v-icon
                        >
                      </template>
                      <span>{{ $t("mail_relay.detail.note") }}</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:item.doc_type_code="{ item }">
                    <div
                      v-for="(list_doc_type, index) in $t('typeCode.all')"
                      :key="index"
                    >
                      <v-chip
                        small
                        class="textCenter"
                        v-if="list_doc_type.value === item.doc_type_code"
                        :color="list_doc_type.color"
                        dark
                        >{{ list_doc_type.text }}</v-chip
                      >
                    </div>
                  </template>
                  <template v-slot:item.active="{ item }">
                    <v-btn
                      tile
                      v-if="item.status"
                      color="success"
                      class="btn-round"
                      small
                      @click="fn_active(item)"
                      :loading="item.loading"
                    >
                      <v-icon left> mdi-eye-outline </v-icon>
                      {{ $t("addpositionsigning.condition.btn_show") }}
                    </v-btn>
                    <v-btn
                      tile
                      v-else
                      color="grey lighten-2"
                      class="btn-round"
                      small
                      @click="fn_active(item)"
                      :loading="item.loading"
                    >
                      <v-icon left> mdi-eye-off-outline </v-icon>
                      {{ $t("addpositionsigning.condition.btn_off") }}
                    </v-btn>
                  </template>
                  <!-- custom action -->
                  <template v-slot:item.action="{ item }">
                    <v-menu offset-y bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          dark
                          v-bind="attrs"
                          v-on="on"
                          small
                          class="mx-2"
                          fab
                          :color="_pageDetailcolor"
                        >
                          <v-icon dark size="20">
                            mdi-format-list-bulleted-square
                          </v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item v-for="(list, i) in itemsAction" :key="i">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                :color="list.color"
                                fab
                                small
                                style="
                                  vertical-align: middle;
                                  cursor: pointer;
                                  margin-left: 5px;
                                  margin-right: 5px;
                                "
                                v-bind="attrs"
                                v-on="on"
                                @click="fn_checkActionType(list.service, item)"
                                ><v-icon small color="white">
                                  {{ list.icon }}</v-icon
                                ></v-btn
                              >
                            </template>
                            <span>{{ list.text }}</span>
                          </v-tooltip>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <!--<v-tooltip right>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="mr-2"
                          color="#f1ce1e"
                          fab
                          small
                          @click="fn_editForm(item)"
                          ><v-icon small color="white"
                            >mdi-pencil-outline</v-icon
                          ></v-btn
                        >
                      </template>
                      <span>{{
                        $t("addpositionsigning.condition.btn_edit")
                      }}</span>
                    </v-tooltip>
                    <v-tooltip right>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          fab
                          small
                          class="mr-2"
                          color="#f05c5a"
                          @click="fn_deleteForm(item)"
                        >
                          <v-icon small color="white"
                            >mdi-delete-outline</v-icon
                          >
                        </v-btn>
                      </template>
                      <span>{{
                        $t("addpositionsigning.condition.btn_delete")
                      }}</span>
                    </v-tooltip>
                    <v-tooltip right>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          fab
                          small
                          class="mr-2"
                          color="blue-grey darken-1"
                          @click="fn_deleteCoppy(item)"
                        >
                          <v-icon small color="white">mdi-content-copy</v-icon>
                        </v-btn>
                      </template>
                      <span>{{
                        $t("addpositionsigning.condition.btn_copy")
                      }}</span>
                    </v-tooltip>-->
                  </template>
                </v-data-table>
                <!-- ปุ่มเลี่ยนหน้า -->
                <v-layout row wrap justify-center align-center>
                  <v-flex xs12 lg12>
                    <v-pagination
                      circle
                      :color="_pageDetailcolor"
                      class="my-4"
                      v-model="page"
                      :total-visible="7"
                      :length="pageCount"
                      prev-icon="mdi-menu-left"
                      next-icon="mdi-menu-right"
                    >
                    </v-pagination>
                  </v-flex>
                </v-layout>
              </div>
            </v-card-text>
            <br />
          </v-card>
        </v-flex>
      </v-layout>
      <!-- updatestatus -->
      <DialogUpdate
        :show="dialogUpdate"
        :_item="itemSelect"
        @closeDialogUpdate="dialogUpdate = false"
        @reData="fn_loadData()"
      />
      <!-- delete -->
      <DialogDelete
        :show="dialogDelete"
        :_item="itemDelete"
        @closeDialogDelete="dialogDelete = false"
        @reData="fn_loadData()"
      />
      <DialoConfirmChoice
        :show="dialogConfirmChoice"
        :item="itemChoice"
        @close="dialogConfirmChoice = false"
        @reData="fn_loadData()"
      />
      <!-- สถานะกำลังโหลดข้อมูล -->
      <div v-if="loadingDownloadData">
        <overlayLoadData />
      </div>
      <!-- copy -->
      <DialogCopy
        :show="dialogCopy"
        :_item="itemSelect"
        @closeDialogCopy="dialogCopy = false"
        @reData="fn_loadData()"
      />
      <!--</v-container>-->
      <!-- ดูคำอธิบายประเภทเอกสาร -->
      <DialogDocType :show="dialogDocType" @close="dialogDocType = false" />
    </v-content>
  </v-app>
</template>
<script>
import authorization from "@/authorization/authorization.js";
import DialogUpdate from "@/components/portal/dialog/bill/portal-dialog-create-bill-update-status";
import DialogDelete from "@/components/portal/dialog/bill/portal-dialog-running-number-delete";
import DialoConfirmChoice from "@/components/portal/dialog/dialo-confirm-choice-runnung.vue";
import DialogTestSystem from "@/components/portal/dialog/dialog-test-system";
import DialogCopy from "@/components/portal/dialog/portal-dialog-coppy-running-number.vue";
import overlayLoadData from "@/components/portal/dialog/portal-overlay-loading-page.vue";
import DialogDocType from "@/components/portal/dialog/report_new/dialog-documentType.vue";
import swal from "sweetalert2";
import { mapGetters, mapState } from "vuex";
export default {
  components: {
    DialogUpdate,
    DialogDelete,
    overlayLoadData,
    DialogTestSystem,
    DialoConfirmChoice,
    DialogCopy,
    DialogDocType,
  },
  mounted() {},
  data() {
    return {
      loadingDownloadData: false,
      itemFilter: [],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      itemDelete: {},
      templateSelect: {},
      seclectStatus: "all",
      search: "",
      updateStatus: "",
      fromissue_date: "",
      toissue_date: "",
      toissuedateMax: "",
      transaction_id: "",
      itemSelect: {},
      modalFromissuedate: false,
      modalToissuedate: false,
      dialogUpdate: false,
      dialogDelete: false,
      itemsSystem: [
        { value: "R1", text: "R1" },
        { value: "R2", text: "R2" },
      ],
      web_service: "R2",
      options: [
        { value: "day", text: "วัน" },
        { value: "month", text: "เดือน" },
        { value: "year", text: "ปี" },
        { value: "", text: "ไม่ระบุ" },
      ],
      itemsAction: [
        {
          icon: "mdi-pencil-outline",
          text: "Edit",
          color: "#f1ce1e",
          service: "Edit",
        },
        {
          icon: "mdi-delete-outline",
          text: "Delete",
          color: "#f05c5a",
          service: "Delete",
        },
        {
          icon: "mdi-content-copy",
          text: "Copy",
          color: "blue-grey darken-1",
          service: "Copy",
        },
      ],
      dialogConfirmChoice: false,
      itemChoice: null,
      check_sourcesystem: false,
      check_branch: false,
      totalItem: 0,
      loading: false,
      dateFilterType: "",
      dialogCopy: false,
      dialogDocType: false,
    };
  },
  async mounted() {
    await this.fn_loadData();
  },
  watch: {},
  methods: {
    fn_descriptionDocType() {
      this.dialogDocType = true;
    },
    fn_loadData: async function () {
      this.loadingDownloadData = true;
      var payload = {
        taxid: this._taxId,
        seller_id: localStorage.etax_sellerid,
        web_service: "R2",
        //web_service: this.web_service,
      };
      var dataEncode = await authorization.encodeData(payload);
      var auth = await authorization.gentoken(this._taxId);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_CREATE_BILL_API + "runnumber/getlist",
          { data: dataEncode },
          { headers }
        )
        .then((res) => {
          if (res.data.status === "OK") {
            this.loadingDownloadData = false;
            this.itemFilter = res.data.message;
            this.totalItem = res.data.message.length;
            this.itemFilter = this.itemFilter.sort((a, b) => {
              return new Date(b.create_dtm) - new Date(a.create_dtm);
            }); // sort by last date create
            var index = 0;
            for (var item of res.data.message) {
              index += 1;
              item["no"] = index;
              // Manage Map name doctype code & name
              //const doc_type = this.$t(
              //  "processlog.condition.doctype_list"
              //).find((e) => {
              //  return e.value === item["doc_type_code"] ? e.text : "";
              //});
              //item["doc_type_name"] = doc_type.text;
            }
            this.fn_getConfig();
          } else {
            this.loadingDownloadData = false;
            swal.fire(this.$t("alert.fail"), res.data.errorMessage, "error");
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            swal.fire(
              this.$t("alert.fail"),
              String(error.response.data.message),
              "error"
            );
            // do something
          } else if (error.request) {
            swal.fire(this.$t("alert.fail"), error.request, "error");
            // do something else
          } else if (error.message) {
            swal.fire(this.$t("alert.fail"), error.message, "error");
            // do something other than the other two
          } else {
            swal.fire(this.$t("alert.fail"), String(error), "error");
          }
        });
    },
    async fn_getConfig() {
      const payload = {
        taxid: this._taxId,
        seller_id: localStorage.etax_sellerid,
        web_service: "R2",
      };
      var dataEncode = await authorization.encodeData(payload);
      var auth = await authorization.gentoken(this._taxId);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_CREATE_BILL_API + "runnumber/get_config",
          { data: dataEncode },
          { headers }
        )
        .then((res) => {
          if (res.data.status === "OK") {
            this.dateFilterType = res.data.message.refreshs;
            this.check_sourcesystem = res.data.message.source_system;
            this.check_branch = res.data.message.branch;
          }
        })
        .catch((error) => {
          if (error.response) {
            swal.fire(
              this.$t("alert.fail"),
              String(error.response.data.message),
              "error"
            );
            // do something
          } else if (error.request) {
            swal.fire(this.$t("alert.fail"), error.request, "error");
            // do something else
          } else if (error.message) {
            swal.fire(this.$t("alert.fail"), error.message, "error");
            // do something other than the other two
          } else {
            swal.fire(this.$t("alert.fail"), String(error), "error");
          }
        });
    },
    fn_active: async function (item) {
      var payload = {
        id: item.id,
        status_template: !item.status,
        taxid: this._taxId,
        web_service: "R2",
      };
      item.loading = true;
      var dataEncode = await authorization.encodeData(payload);
      var auth = await authorization.gentoken(this._taxId);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_CREATE_BILL_API + "runnumber/update_status",
          { data: dataEncode },
          { headers }
        )
        .then((response) => {
          item.loading = false;
          if (response.data.status == "OK") {
            this.fn_loadData();
            swal.fire(
              this.$t("alert.success"),
              this.$t("running_number.swal.save_success"),
              "success"
            );
          } else {
            swal.fire(
              this.$t("alert.fail"),
              response.data.errorMessage,
              "error"
            );
          }
        })
        .catch((error) => {
          item.loading = false;
          swal.fire(
            this.$t("alert.fail"),
            this.$t("running_number.swal.server_err"),
            "error"
          );
        });
    },
    fn_confirmChoice() {
      this.itemChoice = {
        seller_id: localStorage.etax_sellerid,
        tax_id: this._taxId,
      };
      // Check Refresh By
      if (this.dateFilterType === undefined) {
        this.itemChoice.refresh = "";
      } else {
        this.itemChoice.refresh =
          this.dateFilterType.value || this.dateFilterType.value === ""
            ? this.dateFilterType.value
            : this.dateFilterType;
      }
      if (this.check_branch === undefined) {
        this.itemChoice.seller_branch_id = false;
      } else {
        this.itemChoice.seller_branch_id = this.check_branch;
      }
      if (this.check_sourcesystem === undefined) {
        this.itemChoice.source_system = false;
      } else {
        this.itemChoice.source_system = this.check_sourcesystem;
      }
      this.dialogConfirmChoice = true;
    },
    fn_changeStatusProduct: function (item) {
      this.itemSelect = item;
      this.dialogUpdate = true;
    },
    fn_createForm: function () {
      this.$router.push({
        path: "/portal/running_number_new_add",
      });
    },
    fn_checkActionType(val, item) {
      if (val == "Copy") {
        this.fn_deleteCoppy(item);
      } else if (val == "Edit") {
        this.fn_editForm(item);
      } else if (val == "Delete") {
        this.fn_deleteForm(item);
      }
    },
    fn_editForm: async function (item) {
      await this.$router.push({
        path: "/portal/running_number_new_edit",
        query: { doc_type: item.doc_type_code, id: item.id },
      });
    },
    fn_deleteForm: async function (item) {
      this.itemDelete = item;
      this.dialogDelete = true;
    },
    fn_deleteCoppy: async function (item) {
      // ประเภท, source system, สาขา
      this.itemSelect = item;
      this.dialogCopy = true;
    },
  },
  computed: {
    ...mapGetters(["getter_dataBusiness_profile"]),
    ...mapState(["backgroudcolor", "pageDetailcolor"]),

    //dateFilterType: {
    //  get() {
    //    return this.$t("running_number.dateFilterType");
    //  },
    //  set(value) {
    //    return value;
    //  },
    //},
    _taxId: {
      get() {
        return this.getter_dataBusiness_profile["id_card_num"];
      },
    },
    _backgroudcolor: {
      get() {
        return this.backgroudcolor;
      },
    },
    _pageDetailcolor: {
      get() {
        return this.pageDetailcolor;
      },
    },
    headers() {
      return [
        {
          text: this.$t("running_number.table.header_no"),
          align: "center",
          sortable: false,
          value: "no",
          class: "black--text",
        },
        {
          text: this.$t("running_number.table.header_doc_type"),
          align: "left",
          value: "doc_type_code",
          sortable: false,
          class: "black--text",
        },
        {
          text: this.$t("running_number.table.header_branch_id"),
          align: "left",
          value: "branch_id",
          sortable: false,
          class: "black--text",
        },
        {
          text: "Source System",
          align: "left",
          value: "source_system",
          sortable: false,
          class: "black--text",
        },
        {
          text: this.$t("running_number.table.header_form_id"),
          align: "left",
          value: "running_number",
          sortable: false,
          class: "black--text",
        },
        {
          text: this.$t("running_number.table.header_creater_name"),
          align: "left",
          value: "usercode",
          sortable: false,
          class: "black--text",
        },
        {
          text: this.$t("running_number.table.header_create_dtm"),
          align: "center",
          value: "create_dtm",
          sortable: false,
          class: "black--text",
        },
        {
          text: this.$t("running_number.table.header_using"),
          align: "center",
          value: "active",
          sortable: false,
          class: "black--text",
        },
        {
          text: this.$t("running_number.table.header_action"),
          align: "center",
          value: "action",
          sortable: false,
          class: "black--text",
          width: "100px",
        },
      ];
    },
  },
};
</script>
<style scoped>
.btn-round {
  border-radius: 15px;
}
.table-stlye >>> .v-data-table th {
  padding: 0 0px !important;
  /*background-color: #2e394f !important;*/
  background-color: #003399 !important;
  color: rgb(255, 255, 255) !important;
}
.th-stlye >>> th {
  /*border: 1px solid #8fb2ad;*/
  border: 1px solid #bdbdbd;
  border-collapse: collapse !important;
  text-align: center !important;
  height: 40px !important;
}
.textCenter {
  width: 195px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.container,
.container-fluid,
.container-sm,
.container-md,
.container-lg,
.container-xl,
.container-xxl {
  width: 100%;
  padding-right: var(--bs-gutter-x, 0.75rem);
  padding-left: var(--bs-gutter-x, 0.75rem);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container,
  .container-sm {
    max-width: 650px;
  }
}
@media (min-width: 769px) {
  .container,
  .container-sm,
  .container-md {
    max-width: 960px;
  }
}

@media (min-width: 992px) {
  .container,
  .container-sm,
  .container-md,
  .container-lg {
    max-width: 1100px;
  }
}

@media (min-width: 1200px) {
  .container,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl {
    max-width: 1150px;
  }
}

@media (min-width: 1400px) {
  .container,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl,
  .container-xxl {
    max-width: 1180px;
  }
}
</style>
